// Header.tsx
import { useEffect } from 'react';
import Head from 'next/head';
import NextImage from 'next/image';
import { motion, useMotionValue, useTransform, useSpring } from 'motion/react';
import { getMetadataTags } from 'lib/utils/get-metadata-tags';
import * as styled from './styles';

const pageTitle =
  '#1 Daily Probiotic, Multivitamin, Sleep + Energy Supplements';

const metaData = {
  pageTitle,
  pageDescription:
    "Explore Seed's range of daily supplements designed for your gut microbiome and overall health.",
  canonicalUrl: 'https://seed.com/products',
  imageUrl:
    'https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1759517364/structured-data/og-products.png',
  ogImageAlt: pageTitle,
};

const MotionImage = motion(NextImage);

const Header = () => {
  // Animation: zooms out on scroll down and in on up
  const scrollY = useMotionValue(0);
  const scale = useTransform(scrollY, [0, 300], [1.15, 1]);
  const smoothScale = useSpring(scale, {
    stiffness: 80,
    damping: 20,
    mass: 1,
  });

  useEffect(() => {
    const handleScroll = () => {
      scrollY.set(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrollY]);

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
        {getMetadataTags({ ...metaData })}
      </Head>
      <styled.Header>
        <styled.ImageWrapper>
          <MotionImage
            src='https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1758040846/npd/86cf1e11f3d5472b8b0635a056a5f1ed88459968.png'
            alt='three people running in a green field'
            style={{ ...styled.image, scale: smoothScale }}
            fill
            priority
          />
        </styled.ImageWrapper>
        <styled.Overlay />
        <styled.Content>
          <styled.Title>
            Whole Body Health, Made
            <br /> Possible by Your Microbiome
          </styled.Title>
        </styled.Content>
      </styled.Header>
    </>
  );
};

export default Header;
